// extracted by mini-css-extract-plugin
export default {"moreButtonMobile":"Z3mH1x","large":"P4Ex2M"};